<template>
  <div>
    <v-text-field
      :prefix="gananciaLocal ? '%' : ''"
      v-model.number="gananciaLocal"
      v-validate="'required|decimal:2|max:30'"
      :error-messages="errors.collect('ganancia')"
      data-vv-name="ganancia"
      type="number"
      label="Ganancia"
      required
      :outlined="outlined"
      @input="onInputChange"
      @click:append-outer="clickAppendOuter"
    ></v-text-field>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "form.producto.ganancia",
  inject: ["$validator"],
  components: {},
  // $_veeValidate: {
  //   validator: "new",
  // },

  props: {
    producto: {
      type: Object,
      required: false,
    },
    ganancia: {
      type: Number,
      required: false,
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {

      gananciaLocal: this.ganancia != null ? this.ganancia : 0,
    }
    },
    watch: {
    // Si el padre actualiza precioCosto, actualizamos el local
    ganancia(newVal) {
      this.gananciaLocal = newVal ?? 0;
    }
  },

  methods: {
    onInputChange(valor) {
      // Emitimos el nuevo valor al padre
      this.$emit('update:ganancia', valor);
    },
    clickAppendOuter() {
      this.$emit('click-button-append');
    },
  },
  };
</script>

<style lang="scss" scoped></style>
